import React, { ComponentType, ReactNode } from "react";
import OneColLayout from "../containers/Layout/OneColumn";
import TwoColLayout from "../containers/Layout/TwoColumns";
import CustomUsersTwoColumns from "../containers/Layout/CustomUsersTwoColums";
import CustomParametersTwoColumns from "../containers/Layout/CustomParametersTwoColums";
import CustomIndicatorsTwoColumns from "../containers/Layout/CustomIndicatorsTwoColums";
import CustomDevelopersTwoColumns from "../containers/Layout/CustomDevelopersTwoColumns";

interface LayoutProps {
  loading?: boolean;
  children?: ReactNode;
}

export const withOneColLayout = <P extends object>(
  Component: ComponentType<P>
): ComponentType<P & LayoutProps> => {
  const WrappedComponent = (props: P & LayoutProps) => (
    <OneColLayout>
      <Component {...props} />
    </OneColLayout>
  );
  WrappedComponent.displayName = `WithOneColLayout(${
    Component.displayName || Component.name || "Component"
  })`;

  return WrappedComponent;
};

export const withTwoColLayout = <P extends object>(
  Component: ComponentType<P>,
  subheader?: JSX.Element
): ComponentType<P & LayoutProps> => {
  const WrappedComponent = (props: P & LayoutProps) => (
    <TwoColLayout subheader={subheader}>
      <Component {...props} />
    </TwoColLayout>
  );
  WrappedComponent.displayName = `WithTwoColLayout(${
    Component.displayName || Component.name || "Component"
  })`;

  return WrappedComponent;
};

export const customUsersTwoColLayout = <P extends object>(
  Component: ComponentType<P>
): ComponentType<P & LayoutProps> => {
  const WrappedComponent = (props: P & LayoutProps) => (
    <CustomUsersTwoColumns>
      <Component {...props} />
    </CustomUsersTwoColumns>
  );
  WrappedComponent.displayName = `CustomUsersTwoColLayout(${
    Component.displayName || Component.name || "Component"
  })`;

  return WrappedComponent;
};

export const customParametersTwoColLayout = <P extends object>(
  Component: ComponentType<P>
): ComponentType<P & LayoutProps> => {
  const WrappedComponent = (props: P & LayoutProps) => (
    <CustomParametersTwoColumns>
      <Component {...props} />
    </CustomParametersTwoColumns>
  );
  WrappedComponent.displayName = `CustomParametersTwoColLayout(${
    Component.displayName || Component.name || "Component"
  })`;

  return WrappedComponent;
};

export const customDevelopersTwoColLayout = <P extends object>(
  Component: ComponentType<P>
): ComponentType<P & LayoutProps> => {
  const WrappedComponent = (props: P & LayoutProps) => (
    <CustomDevelopersTwoColumns>
      <Component {...props} />
    </CustomDevelopersTwoColumns>
  );
  WrappedComponent.displayName = `CustomDevelopersTwoColLayout(${
    Component.displayName || Component.name || "Component"
  })`;

  return WrappedComponent;
};

export const customIndicatorsTwoColLayout = <P extends object>(
  Component: ComponentType<P>
): ComponentType<P & LayoutProps> => {
  const WrappedComponent = (props: P & LayoutProps) => (
    <CustomIndicatorsTwoColumns>
      <Component {...props} />
    </CustomIndicatorsTwoColumns>
  );
  WrappedComponent.displayName = `CustomIndicatorsTwoColLayout(${
    Component.displayName || Component.name || "Component"
  })`;

  return WrappedComponent;
};
